if (!customElements.get('facet-quick-filter')) {
  customElements.define(
    'facet-quick-filter',
    class FacetQuickFilter extends HTMLButtonElement {
      constructor() {
        super();
        this.onClickHandler = this.onClick.bind(this);
        this.onRerenderHandler = this.syncActiveState.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.onClickHandler);
        document.addEventListener('collection:rerendered', this.onRerenderHandler);
        this.syncActiveState();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClickHandler);
        document.removeEventListener('collection:rerendered', this.onRerenderHandler);
      }

      get targetUrl() {
        return new URL(this.dataset.url, window.location.origin);
      }

      getFacetForm() {
        return document.querySelector('form[is="facet-form"]');
      }

      // Vero quando tutte le coppie chiave/valore del link del bottone
      // sono già presenti nell'URL corrente.
      isActive(url) {
        const params = [...this.targetUrl.searchParams];
        if (params.length === 0) return false;
        return params.every(([key, value]) => url.searchParams.getAll(key).includes(value));
      }

      syncActiveState() {
        const active = this.isActive(new URL(window.location.href));
        this.classList.toggle('btn--active', active);
        this.setAttribute('aria-pressed', active ? 'true' : 'false');
      }

      syncGroupActiveState(isNowActive) {
        // Comportamento "scheda singola": un solo bottone del gruppo è attivo alla volta.
        document.querySelectorAll('[is="facet-quick-filter"]').forEach((btn) => {
          if (btn !== this) {
            btn.classList.remove('btn--active');
            btn.setAttribute('aria-pressed', 'false');
          }
        });
        this.classList.toggle('btn--active', isNowActive);
        this.setAttribute('aria-pressed', isNowActive ? 'true' : 'false');
      }

      onClick(event) {
        const form = this.getFacetForm();

        if (!form || typeof form.renderSection !== 'function') {
          // Rete di sicurezza: se il modulo filtri del tema non è presente
          // su questa pagina, il bottone si comporta come un link normale.
          window.location.href = this.dataset.url;
          return;
        }

        event.preventDefault();

        const currentUrl = new URL(window.location.href);
        const wasActive = this.isActive(currentUrl);
        const targetParams = this.targetUrl.searchParams;

        // Toglie dall'URL corrente ogni chiave di filtro gestita da questo bottone...
        [...new Set(targetParams.keys())].forEach((key) => currentUrl.searchParams.delete(key));

        // ...e la rimette solo se il bottone non era già attivo (click = toggle).
        if (!wasActive) {
          targetParams.forEach((value, key) => currentUrl.searchParams.append(key, value));
        }

        currentUrl.searchParams.delete('page');
        currentUrl.searchParams.set('section_id', FoxTheme.utils.getSectionId(form));

        form.renderSection(currentUrl.toString(), event);

        const historyUrl = new URL(currentUrl);
        historyUrl.searchParams.delete('section_id');
        history.replaceState({}, '', historyUrl.toString());

        this.syncGroupActiveState(!wasActive);
      }
    },
    { extends: 'button' }
  );
}
